import React from "react";
import { useIntl } from "react-intl";

import { ListDescriptionRunsStatusEnum, PlatformDescriptionStatusDTO } from "@app/api/generated";
import { SelectComponent } from "@app/core/select";
import { getPlatformName, orderPlatformsByKeys } from "@app/util/platform-name";

import { RUN_STATUS_LABEL_KEY } from "@app/util/run-status";
import styles from "@app/styles/dashboard/filter-bar.module.scss";

interface IDescriptionFilterBarProps {
  platforms: PlatformDescriptionStatusDTO[];
  statusFilter?: ListDescriptionRunsStatusEnum;
  platformFilter?: number;
  onStatusChange: (status?: ListDescriptionRunsStatusEnum) => void;
  onPlatformChange: (platformId?: number) => void;
}

const DescriptionFilterBar = ({
  platforms,
  statusFilter,
  platformFilter,
  onStatusChange,
  onPlatformChange
}: IDescriptionFilterBarProps): JSX.Element => {
  const intl = useIntl();

  const statusOptions = [
    { id: "", name: intl.formatMessage({ id: "productDescription.filter.allStatuses" }) },
    ...Object.values(ListDescriptionRunsStatusEnum).map((status) => ({
      id: status,
      name: intl.formatMessage({ id: RUN_STATUS_LABEL_KEY[status] })
    }))
  ];

  const platformOptions = [
    { id: 0, name: intl.formatMessage({ id: "productDescription.filter.allPlatforms" }) },
    ...orderPlatformsByKeys(platforms, (platform) => platform.productDescriptionEnabled).map((platform) => ({
      id: platform.platformId,
      name: getPlatformName(intl, platform.platformId, platform.name)
    }))
  ];

  return (
    <div className={styles.filterBar}>
      <SelectComponent
        autoWidth
        value={statusFilter ?? ""}
        options={statusOptions}
        onChange={(e) => {
          const { value } = e.target;
          onStatusChange(value ? (value as ListDescriptionRunsStatusEnum) : undefined);
        }}
      />
      <SelectComponent
        autoWidth
        value={platformFilter ?? 0}
        options={platformOptions}
        onChange={(e) => onPlatformChange(Number(e.target.value) || undefined)}
      />
    </div>
  );
};

export { DescriptionFilterBar };
